<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.33293 4.66661C9.33293 4.29842 9.6314 3.99994 9.99959 3.99994H14.6663C15.0344 3.99994 15.3329 4.29842 15.3329 4.66661V9.33327C15.3329 9.70146 15.0344 9.99994 14.6663 9.99994C14.2981 9.99994 13.9996 9.70146 13.9996 9.33327V6.27608L9.87687 10.3988C9.75791 10.5178 9.64206 10.6337 9.53592 10.7238C9.41935 10.8227 9.27143 10.9291 9.07828 10.9919C8.81049 11.0789 8.52203 11.0789 8.25424 10.9919C8.06109 10.9291 7.91316 10.8227 7.7966 10.7238C7.69046 10.6337 7.57461 10.5178 7.45565 10.3988L5.61577 8.55892C5.47598 8.41914 5.39913 8.34302 5.33968 8.29255C5.33731 8.29054 5.33506 8.28865 5.33293 8.28687C5.33079 8.28865 5.32854 8.29054 5.32617 8.29255C5.26672 8.34302 5.18987 8.41914 5.05008 8.55892L1.80433 11.8047C1.54398 12.065 1.12187 12.065 0.861522 11.8047C0.601172 11.5443 0.601172 11.1222 0.861522 10.8619L4.10727 7.61612C4.11229 7.6111 4.1173 7.60609 4.1223 7.60108C4.24127 7.48209 4.35712 7.36621 4.46327 7.2761C4.57983 7.17714 4.72776 7.07076 4.9209 7.00801C5.18869 6.921 5.47716 6.921 5.74495 7.00801C5.93809 7.07076 6.08602 7.17714 6.20258 7.2761C6.30873 7.36621 6.42458 7.48209 6.54354 7.60108L8.38342 9.44095C8.5232 9.58074 8.60006 9.65686 8.6595 9.70733C8.66187 9.70934 8.66412 9.71123 8.66626 9.713C8.6684 9.71123 8.67065 9.70934 8.67301 9.70733C8.73246 9.65686 8.80932 9.58074 8.9491 9.44095L13.0568 5.33327H9.99959C9.6314 5.33327 9.33293 5.0348 9.33293 4.66661Z"
    fill="currentColor"
  />
</svg>
